import { render, staticRenderFns } from "./Articulos.vue?vue&type=template&id=34aa381d&scoped=true&"
import script from "./Articulos.vue?vue&type=script&lang=js&"
export * from "./Articulos.vue?vue&type=script&lang=js&"
import style0 from "./Articulos.vue?vue&type=style&index=0&id=34aa381d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aa381d",
  null
  
)

export default component.exports